import {
    getUserCompany,
    // getUserDepartmentList,
    // getUserDepartmentTargetList,
    getUserList,
    getUserMenu,
    getUserRoleList,
    login,
    quickLogin,
    logout,
    resetPassword,
    setUserModify,
    AdminCompanyModify,
    UserExport,   
    getStationGroupList, 
} from '@/api/user'
import {getToken, removeToken, setToken, setGuestSessionFlag, clearGuestSessionFlag} from '@/utils/auth'
import {resetRouter} from '@/router'
import {generateDepartmentList, generateSlideData} from "@/utils/data-generator";


// 用户记录
const state = {
    // token: getToken(),
    departmentName: '',//部门名称
    departmentId: 0,
    token: 0,
    userId: 0,//用户id
    name: '',//用户姓名
    telNo: '',//电话
    mail: '',//邮箱
    roleId: -1,//角色ID,
    roleName: '',//角色名称,
    sDate: '',//有效开始时间
    eDate: '',//有效截止时间
    isAdmin: false,//是否部门管理员
    rowTime: '',//添加时间
    slideData: [],//侧边栏数据
    sidebarDefaultIndex: 'Home/Index',//侧边栏数据
    companyId: -1,//所在公司Id
    userList: [],//用户列表数据
    departmentList: [],//部门列表
    roleList: [],//角色列表
    departmentTargetList: [],//部门指标列表
    ul:[],
    stationGroupList:[],
    // systemTitle:'',
    simpleUserId:0,//超链进入
    simpleName:'',
    guestSession:false
};

const mutations = {
    SET_USER: (state, user) => {
        state.userId = user.userId;
        state.departmentName = user.departmentName;
        state.departmentId = user.departmentId;
        state.name = user.name;
        state.telNo = user.telNo;
        state.mail = user.mail;
        state.roleId = user.roleId;
        state.roleName = user.roleName;
        state.sDate = user.sDate;
        state.eDate = user.eDate;
        state.isAdmin = user.isAdmin;
        state.rowTime = user.rowTime;
        state.token = user.userId;
        state.userName=user.userName;
        state.password=user.pswd;
    },
    SET_SIMPLE_USER: (state, user) => {
        state.simpleUserId = user.userId;
        state.simpleName = user.name;
    },
    SET_GUEST_SESSION: (state, flag) => {
        state.guestSession = !!flag;
    },
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_INTRODUCTION: (state, introduction) => {
        state.introduction = introduction
    },
    SET_NAME: (state, name) => {
        state.name = name
    },
    SET_ROLENAME: (state, roleName) => {
        state.roleName = roleName
    },
    SET_AVATAR: (state, avatar) => {
        state.avatar = avatar
    },
    SET_SLIDE_DATA: (state, slideData) => {
        state.slideData = slideData
    },
    SET_COMPANY_ID: (state, companyInfo) => {
        // console.log('do set companyid',companyInfo)
        state.companyId = companyInfo;
    },
    
    SET_DEPARTMENT_LIST: (state, list) => {
        state.departmentList = list;
    },
    SET_ROLE_LIST: (state, list) => {
        state.roleList = list;
    },
    SET_USER_LIST: (state, list) => {
        state.userList = list;
        state.ul = list;
    },
    SET_ROLE_LIST_ITEM: (state, roleItem) => {
        const {roleId} = roleItem;
        if (roleId) {
            for (let item of state.roleList) {
                if (roleId === item.roleId) {
                    item = roleItem;
                    break;
                }
            }
        }
    },
    SET_DEPARTMENT_TARGET_LIST: (state, list) => {
        state.departmentTargetList = list;
    },
    SET_USER_LIST_ITEM: (state, user) => {
        const {userId} = user;
        let itemIndex = state.userList.findIndex(item => userId === item.userId);
        if (itemIndex !== -1) {
            state.userList[itemIndex] = user;
        } else {
            state.userList.unshift(user);
        }
    },
    stationGroupList: (state, list) => {
        state.stationGroupList = list;
    },

    // SET_SystemTitle: (state, title) => {
    //     state.systemTitle = title;
    // },
}

const actions = {
    // user login
    login({commit}, userInfo) {
        const {username, password,isZC} = userInfo
        return new Promise((resolve, reject) => {
            login({uName: username.trim(), uPswd: password,isZC}).then(response => {
                const {data: [user], code} = response
                // console.log('code',code);
                if (code === 1) {
                    // console.log('data=', user);
                    commit('SET_USER', user);
                    setToken(user.userId)
                    resolve()
                } else {
                    reject(new Error('账号或密码错误'));
                }
            }).catch(error => {
                reject(error)
            })
        })
    },

    quickLogin({commit}, {token,toPath}) {     
        
        return new Promise((resolve, reject) => {
            quickLogin({token,toPath}).then(response => {
                const {data: [user], code} = response
                // console.log('code',code);
                if (code === 1) {
                    // console.log('data=', user);
                    commit('SET_USER', user);
                    setToken(user.userId)
                    resolve()
                } else {
                    reject(new Error('登录口令错误或过期'));
                }
            }).catch(error => {
                reject(error)
            })
        })
    },

    quickLogin2024({commit}, {token,toPath}) {

        return new Promise((resolve, reject) => {
            quickLogin({token,toPath}).then(response => {
                const {data: [user], code} = response
                // console.log('code',code);
                if (code === 1) {
                    // console.log('data=', user);
                    commit('SET_SIMPLE_USER', user);
                    // 后端已通过 Set-Cookie 下发 HttpOnly Guest-Session cookie
                    // 前端仅使用 sessionStorage 存储访客标志（浏览器关闭自动清除）
                    // 同时设置 Admin-Token = userId，确保组件中 getToken() 可获取用户ID
                    setToken(user.userId)
                    setGuestSessionFlag()
                    commit('SET_GUEST_SESSION', true);
                    resolve()
                } else {
                    reject(new Error('登录口令错误或过期'));
                }
            }).catch(error => {
                reject(error)
            })
        })
    },

    async getUserMenu({commit, state}) {
        return getUserMenu({userId: state.token}).then(response => {
            const {data} = response;
            commit('SET_SLIDE_DATA', generateSlideData({data}));
        });
    },

    async getUserCompany({commit, state}) {
        return getUserCompany({userId: getToken()}).then(response => {
            commit('SET_COMPANY_ID', response.data[0].companyId);
        });
    },

    async getUserRoleList({commit, state}, key = '') {
        return getUserRoleList({userId: getToken(), key}).then(response => {
            commit('SET_ROLE_LIST', response.data);
        })
    },


    async getUserList({commit, state,dispatch}, key = '') {
        return getUserList({userId: getToken(),key}).then(response => {
            commit('SET_USER_LIST', response.data);
        });
    },

    async setUserModify({commit, state}, {userId, userName, name, telNo, mail, companyId, roleId, sDate = '', eDate = '', isAdmin,stationGroupIdStr,moniTypeIds, optUserId}) {
        return setUserModify({
            uId: userId,
            userName,
            name,
            telNo,
            mail,
            departmentId:companyId,
            roleId,
            sDate: '',//sDate.split('T').shift(),
            eDate: '',//eDate.split('T').shift(),
            stationGroupId:stationGroupIdStr,
            moniTypeIds,
            isAdmin,
            optUserId: state.token
        }).then(response => {
            commit('SET_USER_LIST_ITEM', response.data[0]);
        });

    },

    async AdminCompanyModify({commit, state}, {companyId, companyName,companyCode,logo='',typeId, gradeId,account='',bank='',regAmount='',regDate='',address='',contactUser='',tel=''}) {
        return AdminCompanyModify({
            companyId,
            companyName,
            companyCode,
            logo,
            typeId, 
            gradeId,
            account,
            bank,
            regAmount,
            regDate,
            address,
            contactUser,
            tel,
            uId: state.token
        }).then(
            // response => {
            //     commit('SET_USER_LIST_ITEM', response.data[0]);
            // }
        );

    },
  
    // user logout
    logout({commit, state, dispatch}) {
        return new Promise((resolve, reject) => {
            logout(state.token).then(() => {
                commit('SET_TOKEN', '')
                commit('SET_ROLES', [])
                commit('SET_GUEST_SESSION', false);
                removeToken()
                clearGuestSessionFlag()
                resetRouter()

                // reset visited views and cached views
                // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
                dispatch('tagsView/delAllViews', null, {root: true})

                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },

    resetPassword({commit}, userInfo) {
        const {username, password} = userInfo;
        return new Promise((resolve, reject) => {
            resetPassword({uName: username, newPswd: password}).then(response => {
                const {code} = response;
                if (code === 1) {
                    resolve();
                } else {
                    reject()
                }
            }).catch(reject);
        })

    },
    // remove token
    resetToken({commit}) {
        return new Promise(resolve => {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            removeToken()
            resolve()
        })
    },

    async UserExport({commit}, {sDate,eDate}) {
        return UserExport({
            sDate,eDate,
            userId: getToken(),
        });
    },

    async stationGroupList({commit}, {userId} = {}) {
        const {data} = await getStationGroupList({
            userId: userId || getToken()
        });
        // console.log('data',data)
        commit('stationGroupList', data);
    },

    // setSystemTitle({commit}, title) {
    //     return commit('SET_SystemTitle', title);
    // },

}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
